import * as React from 'react';
import { Col } from 'react-bootstrap';

const ImageUploadInProgressSkeleton = () => {
    return (
        <Col xs={12} sm={6} md={4} lg={3}>
            <div
                className={'thumbnail thumbnail-custom'}
                style={{
                    display: 'flex',
                    maxHeight: '237px'
                }}
            >
                <div className="skeleton" />
                <div className="img-responsive-spinner">
                    <span className="spin-container">
                        <i className="load-spin-dark" />
                    </span>
                </div>
            </div>
        </Col>
    );
};

export default ImageUploadInProgressSkeleton;
